export const DATA_HOOKS = {
  DATA_STATUS_EMPTY_QUERY_ATTR: 'query-empty',
  DATA_STATUS_SUCCESS_ATTR: 'success',
  DATA_STATUS_LOADING_ATTR: 'loading',
  DATA_STATUS_ERROR_ATTR: 'error',
};
